import { useEffect } from 'react';
import { RouterConfiguration } from '../../routes/RouterConfiguration';
import { registerMedia } from '../../services/MediaRegistrationService';
import { initAppDomains } from '../../states/AppDomainProvider';
import IOSHeartbeatService from '../../services/IOSHeartbeatService';
import VizzleEventListenerContainer from '../vizzle/VizzleEventListenerContainer';
import './App.scss';
import '../../styles/accessibility.scss';
import { useInitializationWhenLogin } from './AppHooks';
import MicrosoftCopilot from '../../components/copilot/MicrosoftCopilot';
import datadogRum from '../../components/datadog-rum';

const preventEvent = (e) => {
  e.preventDefault();
};

const registerMediaAndTts = () => {
  registerMedia();
};

const handleBeforeUnload = (e) => {
  // stop datadog rum session
  datadogRum.userLogout();
  e.preventDefault();
  e.returnValue = ''; // This is necessary for some browsers to show the confirmation dialog
};

function App() {
  initAppDomains();
  const { user } = useInitializationWhenLogin();

  useEffect(() => {
    // Prevent the user drag and drop a file to the app and causes the browser open the file
    window.addEventListener('dragover', preventEvent, false);
    window.addEventListener('drop', preventEvent, false);

    // Register media elements for IOS
    window.addEventListener('mousedown', registerMediaAndTts, { once: true });

    // Make sure we end the user session in datadog when the user closes the tab or navigates away
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Start iOS heartbeat to maintain app responsiveness
    IOSHeartbeatService.startHeartbeat();

    // Cleanup the state
    return () => {
      window.removeEventListener('drop', preventEvent);
      window.removeEventListener('dragover', preventEvent);

      window.removeEventListener('mousedown', registerMediaAndTts, { once: true });

      window.removeEventListener('beforeunload', handleBeforeUnload);

      // Stop the heartbeat on app unmount
      IOSHeartbeatService.stopHeartbeat();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='App'>
      <RouterConfiguration />
      <VizzleEventListenerContainer />
      {user.copilot && <MicrosoftCopilot />}
    </div>
  );
}

export default App;
